import { render, staticRenderFns } from "./withdraw_switch.vue?vue&type=template&id=fb3fa3dc&"
import script from "./withdraw_switch.vue?vue&type=script&lang=js&"
export * from "./withdraw_switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports